// extracted by mini-css-extract-plugin
module.exports = {"globals":"\"../../GlobalStyles.css\"","defaultColor":"#9CCEF9","activeColor":"#7cf4fe","hoverColor":"#ffffff"};